import request from '@/utils/request'
import BaseUrl from '@/config/index'

// 公共接口
// 每个接口中的：takePeeridAndSessionid代表需要把peerid和sessionid都加进参数里，在request.js里统一处理，不再每个接口里都加这2个字段
export default {
  // 获取peerid值
  peerid: (data) => {
    return request({
      data,
      url: '/basic/peerid',
      method: 'GET'
    })
  },
  // 获取扫码登录的二维码图片
  qrcodePic: (data) => {
    return request({
      data,
      url: '/basic/qrcode_id',
      method: 'GET'
    })
  },
  // 项目库列表
  projectList: (data) => {
    return request({
      data,
      url: '/index/project/get_plat_project',
      method: 'GET'
    })
  },
  // 公共配置类型明细列表
  basicConfigType: (data) => {
    return request({
      data,
      url: `/basic/get_common_config_type`,
      method: 'get',
      takePeeridAndSessionid: true
    })
  },
  // 查询公司列表
  searchCompanyData: (data) => {
    return request({
      data,
      url: `/project/company_list_search`,
      method: 'get',
      takePeeridAndSessionid: true
    })
  },
  // 上传附件
  upLoadFile: (data, pathData) => {
    return request({
      data,
      headers: {
        'Content-type': 'multipart/form-data'
      },
      url: BaseUrl.upload + `${pathData.peerid}/${pathData.sessionid}`,
      method: 'POST'
    })
  }
}
